import { Stats } from '../types'
import { ReaderSummaryStatus } from '../ctx/reader_summary/types'

export const getZeroStateSummary = (year: number) =>
  `Add 3 books towards your ${year} Reading Goal and we'll update your Reader Summary!`

export const isSummaryValid = (stats: Stats | null) => {
  return (
    !!stats?.summary_opt_in &&
    !!stats?.summary?.length &&
    !!stats?.summary_id?.length
  )
}

export const canViewSummary = ({
  isSelfView,
  stats,
}: {
  isSelfView?: boolean
  stats: Stats | null
}) => {
  const summaryOptIn = !!stats?.summary_opt_in
  const summaryFeedback = stats?.summary_feedback || 'unselected'
  return isSelfView || (summaryOptIn && summaryFeedback !== 'negative')
}

export const getSummaryVisibilityStatus = ({
  isSelfView,
  isUserOptedIn,
  stats,
}: {
  isSelfView?: boolean
  isUserOptedIn?: boolean
  stats: Stats | null
}) => {
  const summaryOptIn = !!stats?.summary_opt_in
  const canView = !!isUserOptedIn && canViewSummary({ isSelfView, stats })
  const valid = isSummaryValid(stats)

  const getStatus = (): ReaderSummaryStatus => {
    const isInvalidOtherUser = !isSelfView && (!valid || !canView)
    const isPrior2025 = (stats?.year ?? 0) < 2025
    if (isInvalidOtherUser || isPrior2025) return 'hidden'
    return summaryOptIn ? 'success' : 'hidden'
  }

  return { status: getStatus(), isZeroState: !valid, canView }
}
